/* tslint:disable:max-line-length */
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest, HttpEvent, HttpEventType, HttpProgressEvent } from '@angular/common/http';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/catch';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators/map';
import { tap } from 'rxjs/operators/tap';

@Injectable()
export class DataService {
    private serverBase: string;
    public searchTextSubject: BehaviorSubject<string>;
    public searchTextObservable: Observable<string>;
    public scrollSubject: BehaviorSubject<{ x: number, y: number }>;
    public scrollObservable: Observable<{ x: number, y: number }>;
    public homeLinkSubject: BehaviorSubject<boolean>;
    public homeLinkObservable: Observable<boolean>;
    public scrollMemory: any;
    private reqLoop: any;

    constructor(private _http: HttpClient,
        private _spinner: NgxSpinnerService) {
        this.serverBase = environment.serverBase;
        this.searchTextSubject = new BehaviorSubject('');
        this.searchTextObservable = this.searchTextSubject.asObservable();
        this.homeLinkSubject = new BehaviorSubject(false);
        this.homeLinkObservable = this.homeLinkSubject.asObservable();

        this.scrollMemory = { "home": { "prev": { x: 0, y: 0 }, "curr": { x: 0, y: 0 } } };
        this.reqLoop = {};

    }

    get(url, params?: any): Observable<any> {
        this._spinner.show();
        return this._http.get(this.serverBase + url, { params: params || {} })
            .map(response => {
                this._spinner.hide();
                if (response) {
                    return response;
                }
            }).catch((error: HttpErrorResponse) => {
                this._spinner.hide();
                // console.log(error);
                return Observable.throw(error || 'Internal server error');
            });
    }

    getProgressBarValueFromDB(url, params?: any): Observable<any> {
        return this._http.get(this.serverBase + url, { params: params || {} })
            .map(response => {
                if (response) {
                    return response;
                }
            }).catch((error: HttpErrorResponse) => {
                // console.log(error);
                return Observable.throw(error || 'Internal server error');
            });
    }

    post(url: String, data: any, meta: { showBusy?: boolean, isLoop?: boolean, loopLength?: number, count?: string } = { showBusy: true, isLoop: false, loopLength: 0, count: 'nl__0' }): Observable<any> {
        if (meta.showBusy) { this._spinner.show(); }
        const apiEndpoint = `${this.serverBase}${url}`;
        const opts: any = {};
        // console.log(`Reaching endpoint: ${apiEndpoint}`);

        opts.responseType = data.responseType || 'json';
        opts.reportProgress = true;
        // opts.observe = 'events';

        return this._http.post(apiEndpoint, data, opts)
            .map(response => {
                if (!meta.isLoop) { this._spinner.hide(); }
                else {
                    const parts = meta.count.split('__'), reqName = parts[0] || 'nl', reqCount = parts[1] || 0;
                    if (!(this.reqLoop[reqName] || []).length) { this.reqLoop[reqName] = []; }

                    this.reqLoop[reqName].push(reqCount);
                    // if (this.reqLoop[reqName].length == meta.loopLength || this.reqLoop[reqName].length == meta.loopLength - 1) {
                    //     this._spinner.hide();
                    //     response[`${reqName}_status`] = 100;
                    //     this.reqLoop[reqName] = [];
                    // } else { response[`${reqName}_status`] = parseInt(`${(this.reqLoop[reqName].length * 100 / (meta.loopLength - 1))}`, 10); }
                }
                if (response) {
                    return response;
                }
            })
            .catch((error: HttpErrorResponse) => {
                this._spinner.hide();
                // console.log(error);
                return Observable.throw(error || 'Internal server error');
            });
    }

    postForDownloadingFileWithProgress(url: String, data: any, meta: { observeType?: string } = { observeType: 'response' }): Observable<any> {
        // this._spinner.show();
        const apiEndpoint = `${this.serverBase}${url}`;
        // console.log(`Reaching endpoint: ${apiEndpoint}`);
        const opts: any = {};
        if (url.toLowerCase().includes('download')) {
            opts.responseType = 'blob';         // 'blob' (for AWS download from URL) OR 'application/octet-stream' in general
            opts.reportProgress = true;
            opts.observe = meta.observeType;
        }

        // this._spinner.hide();
        let progress = 0;
        return this._http.post(apiEndpoint, data, opts)
            .pipe(
                tap((event: any) => {
                    // This won't work as observe is 'response'.
                    if (event.type == HttpEventType.DownloadProgress) {
                        progress = (event.loaded / (event.total || 1)) * 100;
                    }
                }),
                map((result: any) => {
                    if (result.type == HttpEventType.Response && result.body instanceof Blob) {
                        const n = result.headers.get('Content-Disposition').split('filename="')[1].split('"')[0];
                        return { fileName: n, fileBlob: result.body };
                    } else if (result.type == HttpEventType.DownloadProgress) {
                        return { progress };
                    }

                }))
            .catch((error: HttpErrorResponse) => {
                if (error.error.eventPhase == 2) {
                    return;
                }
                // console.log(error);
                return Observable.throw(error || 'Internal server error');
            });
    }

    put(url: String, data: any): Observable<any> {
        this._spinner.show();
        const apiEndpoint = `${this.serverBase}${url}`;
        // console.log(`Reaching endpoint: ${apiEndpoint}`);
        return this._http.put(apiEndpoint, data, {}).map(response => {
            this._spinner.hide();
            if (response) {
                return response;
            }
        }).catch((error: HttpErrorResponse) => {
            this._spinner.hide();
            // console.log(error);
            return Observable.throw(error || 'Internal server error');
        });
    }

    delete(url: String, id: any): Observable<any> {
        // this._spinner.show();
        const apiEndpoint = `${this.serverBase}${url}`;
        // console.log(`Reaching endpoint: ${apiEndpoint}`);
        const options = {
            // headers: headers
        };
        return this._http.delete(apiEndpoint + '/' + id, options)
            .map(response => {
                this._spinner.hide();
                if (response) {
                    return response;
                }
            }).catch((error: HttpErrorResponse) => {
                this._spinner.hide();
                // console.log(error);
                return Observable.throw(error || 'Internal server error');
            });
    }

    downloadFile(body: any, URL: String) {
        this._spinner.show();
        return this._http.post(this.serverBase + URL, body, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
        });
    }

    _errorHandler(error: HttpErrorResponse) {
        this._spinner.hide();
        return Observable.throw(error || 'Internal server error');
    }

    getCountries(): Array<string> {
        return [
            "United States",
            "Canada",
            "-------------",
            "Afghanistan",
            "Aland Islands",
            "Albania",
            "Algeria",
            "American Samoa",
            "Andorra",
            "Angola",
            "Anguilla",
            "Antarctica",
            "Antigua and Barbuda",
            "Argentina",
            "Armenia",
            "Aruba",
            "Australia",
            "Austria",
            "Azerbaijan",
            "Bahamas",
            "Bahrain",
            "Bangladesh",
            "Barbados",
            "Belarus",
            "Belgium",
            "Belize",
            "Benin",
            "Bermuda",
            "Bhutan",
            "Bolivia",
            "Bosnia and Herzegovina",
            "Botswana",
            "Bouvet Island",
            "Brazil",
            "British Indian Ocean Territory",
            "Brunei Darussalam",
            "Bulgaria",
            "Burkina Faso",
            "Burundi",
            "Cambodia",
            "Cameroon",
            "Cape Verde",
            "Cayman Islands",
            "Central African Republic",
            "Chad",
            "Chile",
            "China",
            "Christmas Island",
            "Cocos (Keeling) Islands",
            "Colombia",
            "Comoros",
            "Congo",
            "Cook Islands",
            "Costa Rica",
            "Cote D'Ivoire (Ivory Coast)",
            "Croatia (Hrvatska)",
            "Cuba",
            "Cyprus",
            "Czech Republic",
            "Democratic Republic Of The Congo",
            "Denmark",
            "Djibouti",
            "Dominica",
            "Dominican Republic",
            "East Timor",
            "Ecuador",
            "Egypt",
            "El Salvador",
            "Equatorial Guinea",
            "Eritrea",
            "Estonia",
            "Ethiopia",
            "Falkland Islands (Malvinas)",
            "Faroe Islands",
            "Federated States Of Micronesia",
            "Fiji",
            "Finland",
            "France",
            "France, Metropolitan",
            "French Guiana",
            "French Polynesia",
            "French Southern Territories",
            "Gabon",
            "Gambia",
            "Georgia",
            "Germany",
            "Ghana",
            "Gibraltar",
            "Great Britain (UK)",
            "Greece",
            "Greenland",
            "Grenada",
            "Gaudeloupe",
            "Guam",
            "Guatemala",
            "Guinea",
            "Guinea-Bissau",
            "Guyana",
            "Haiti",
            "Heard Island and McDonald Islands",
            "Honduras",
            "Hong Kong",
            "Hungary",
            "Iceland",
            "India",
            "Indonesia",
            "Iran",
            "Iraq",
            "Ireland",
            "Israel",
            "Italy",
            "Jamaica",
            "Japan",
            "Jordan",
            "Kazakhstan",
            "Kenya",
            "Kiribati",
            "Korea (North)",
            "Korea (South)",
            "Kuwait",
            "Kyrgyzstan",
            "Laos",
            "Latvia",
            "Lebanon",
            "Lesotho",
            "Liberia",
            "Libya",
            "Liechtenstein",
            "Lithuania",
            "Luxembourg",
            "Macao",
            "Macedonia",
            "Madagascar",
            "Malawi",
            "Malaysia",
            "Maldives",
            "Mali",
            "Malta",
            "Marshall Islands",
            "Martinique",
            "Mauritania",
            "Mauritius",
            "Mayotte",
            "Mexico",
            "Moldova",
            "Monaco",
            "Mongolia",
            "Montenegro",
            "Montserrat",
            "Morocco",
            "Mozambique",
            "Myanmar",
            "Namibia",
            "Nauru",
            "Nepal",
            "Netherlands",
            "Netherlands Antilles",
            "New Caledonia",
            "New Zealand (Aotearoa)",
            "Nicaragua",
            "Niger",
            "Nigeria",
            "Niue",
            "Norfolk Island",
            "Northern Mariana Islands",
            "Norway",
            "Oman",
            "Pakistan",
            "Palau",
            "Palestinian Territory",
            "Panama",
            "Papua New Guinea",
            "Paraguay",
            "Peru",
            "Philippines",
            "Pitcairn",
            "Poland",
            "Portugal",
            "Puerto Rico",
            "Qatar",
            "Reunion",
            "Romania",
            "Russian Federation",
            "Rwanda",
            "Saint Helena",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Pierre and Miquelon",
            "Saint Vincent and the Grenadines",
            "Samoa",
            "San Marino",
            "Sao Tome and Principe",
            "Saudi Arabia",
            "Senegal",
            "Serbia",
            "Seychelles",
            "S. Georgia and S. Sandwich Islands",
            "Sierra Leone",
            "Singapore",
            "Slovakia",
            "Slovenia",
            "Solomon Islands",
            "Somalia",
            "South Africa",
            "Spain",
            "Sri Lanka",
            "Sudan",
            "Suriname",
            "Svalbard and Jan Mayen",
            "Swaziland",
            "Sweden",
            'Switzerland',
            "Syria",
            "Taiwan",
            "Tajikistan",
            "Tanzania",
            "Thailand",
            "Timor-Leste",
            "Togo",
            "Tokelau",
            "Tonga",
            "Trinidad and Tobago",
            "Tunisia",
            "Turkey",
            "Turkmenistan",
            "Turks and Caicos Islands",
            "Tuvalu",
            "Uganda",
            "Ukraine",
            "United Arab Emirates",
            "United Kingdom",
            "United States Minor Outlying Islands",
            "Uruguay",
            "USSR (former)",
            "Uzbekistan",
            "Vanuatu",
            "Vatican City State (Holy See)",
            "Venezuela",
            "Viet Nam",
            "Virgin Islands (British)",
            "Virgin Islands (U.S.)",
            "Wallis and Futuna",
            "Western Sahara",
            "Yemen",
            "Yugoslavia (former)",
            "Zaire (former)",
            "Zambia",
            "Zimbabwe"
        ];
    }
    getUSStates(): Array<string> {
        return [
            "Select this option if NOT in US / Canada",
            "---------",
            "AA",
            "AE",
            "Alabama",
            "Alaska",
            "American Samoa",
            "AP",
            "Arizona",
            "Arkansas",
            "California",
            "Colorado",
            "Connecticut",
            "Delaware",
            "District of Columbia",
            "Federated States Of Micronesia",
            "Florida",
            "Georgia",
            "Guam",
            "Hawaii",
            "Idaho",
            "Illinois",
            "Indiana",
            "Iowa",
            "Kansas",
            "Kentucky",
            "Louisiana",
            "Maine",
            "Marshall Islands",
            "Maryland",
            "Massachusetts",
            "Michigan",
            "Minnesota",
            "Mississippi",
            "Missouri",
            "Montana",
            "Nebraska",
            "Nevada",
            "New Hampshire",
            "New Jersey",
            "New Mexico",
            "New York",
            "North Carolina",
            "North Dakota",
            "Northern Mariana Islands",
            "Ohio",
            "Oklahoma",
            "Oregon",
            "Palau",
            "Pennsylvania",
            "Puerto Rico",
            "Rhode Island",
            "South Carolina",
            "South Dakota",
            "Tennessee",
            "Texas",
            "Utah",
            "Vermont",
            "Virginia",
            "Virginia Islands",
            "Washington",
            "West Virginia",
            "Wisconsin",
            "Wyoming",
            "---------",
            "Alberta",
            "British Columbia",
            "Manitoba",
            "New Brunswick",
            "Newfoundland and Labrador",
            "Northwest Territories",
            "Nova Scotia",
            "Nunavut",
            "Ontario",
            "Prince Edward Island",
            "Quebec",
            "Saskatchewan",
            "Yukon"
        ];
    }

    getWhatBestDescribesYou(): Array<string> {
        return [
            "Before/After School",
            "Bilingual/ELL",
            "Business/Finance/Purchasing",
            "Curriculum & Instruction",
            "District Administrator",
            "Elementary Teacher",
            "English Language Arts Teacher",
            "High School Teacher",
            "Kindergarten Teacher",
            "Librarian/Media Specialist",
            "Mathematics Teacher",
            "Middle School Teacher",
            "Parent",
            "Principal",
            "Resource Teacher/Specialist",
            "Science Teacher",
            "Social Studies Teacher",
            "Special Education",
            "Staff Development",
            "Technology",
            "Title I",
            "Other"
        ];
    }

    setContentSearchString() {

    }

    getZipcodes(): ({ Min: number; Max: number; State: string } | { Min: number; Max: number; State: string })[] {
        return [
             {
                "State": "AA",
                "Min": 34001,
                "Max": 34095
            }, {
                "State": "AE",
                "Min": 9001,
                "Max": 9977
            }, {
                "State": "AP",
                "Min": 96201,
                "Max": 96698
            }, {
                "State": "Alabama",
                "Min": 35004,
                "Max": 36925
            }, {
                "State": "Alaska",
                "Min": 99501,
                "Max": 99950
            }, {
                "State": "Arizona",
                "Min": 85001,
                "Max": 86556
            }, {
                "State": "Arkansas",
                "Min": 71601,
                "Max": 72959
            }, {
                "State": "California",
                "Min": 90001,
                "Max": 96162
            }, {
                "State": "Colorado",
                "Min": 80001,
                "Max": 81658
            }, {
                "State": "Connecticut",
                "Min": 6001,
                "Max": 6928
            }, {
                "State": "Delaware",
                "Min": 19701,
                "Max": 19980
            }, {
                "State": "Florida",
                "Min": 32003,
                "Max": 34997
            }, {
                "State": "Georgia",
                "Min": 30002,
                "Max": 39901
            }, {
                "State": "Hawaii",
                "Min": 96701,
                "Max": 96898
            }, {
               "State": "Idaho",
                "Min": 83201,
                "Max": 83877
            }, {
                "State": "Illinois",
                "Min": 60001,
                "Max": 62999
            }, {
                "State": "Indiana",
                "Min": 46001,
                "Max": 47997
            }, {
               "State": "Iowa",
                "Min": 50001,
                "Max": 52809
            }, {
                "State": "Kansas",
                "Min": 66002,
                "Max": 67954
            }, {
                "State": "Kentucky",
                "Min": 40003,
                "Max": 42788
            }, {
                "State": "Louisiana",
                "Min": 70001,
                "Max": 71497
            }, {
                "State": "Maine",
                "Min": 3901,
                "Max": 4992
            }, {
               "State": "Maryland",
                "Min": 20588,
                "Max": 21930
            }, {
                "State": "Massachusetts",
                "Min": 1001,
                "Max": 5544
            }, {
                 "State": "Michigan",
                "Min": 48001,
                "Max": 49971
            }, {
                "State": "Minnesota",
                "Min": 55001,
                "Max": 56763
            }, {
                "State": "Mississippi",
                "Min": 38601,
                "Max": 39776
            }, {
                "State": "Missouri",
                "Min": 63001,
                "Max": 65899
            }, {
                "State": "Montana",
                "Min": 59001,
                "Max": 59937
            }, {
                "State": "Nebraska",
                "Min": 68001,
                "Max": 69367
            }, {
                "State": "Nevada",
                "Min": 88901,
                "Max": 89883
            }, {
                "State": "New Hampshire",
                "Min": 3031,
                "Max": 3897
            }, {
                "State": "New Jersey",
                "Min": 7001,
                "Max": 8989
            }, {
                "State": "New Mexico",
                "Min": 87001,
                "Max": 88439
            }, {
                "State": "New York",
                "Min": 501,
                "Max": 14925
            }, {
                "State": "North Carolina",
                "Min": 27006,
                "Max": 28909
            }, {
                "State": "North Dakota",
                "Min": 58001,
                "Max": 58856
            }, {
                "State": "Ohio",
                "Min": 43001,
                "Max": 54999
            }, {
                "State": "Oklahoma",
                "Min": 73001,
                "Max": 74966
            }, {
                "State": "Oregon",
                "Min": 97001,
                "Max": 97920
            }, {
                "State": "Pennsylvania",
                "Min": 15001,
                "Max": 19640}
            , {
                "State": "Rhode Island",
                "Min": 2801,
                "Max": 2940
            }, {
                "State": "South Carolina",
                "Min": 29001,
                "Max": 29945
            }, {
                "State": "South Dakota",
                "Min": 57001,
                "Max": 57799
            }, {
                "State": "Tennessee",
                "Min": 37010,
                "Max": 38589
            }, {
                "State": "Texas",
                "Min": 73301,
                "Max": 88595
            }, {
                "State": "Utah",
                "Min": 84001,
                "Max": 84791
            },  {
                "State": "Vermont",
                "Min": 5001,
                "Max": 5907
            },
            {
                "State": "Virginia",
                "Min": 20101,
                "Max": 24658
            },
            {
                "State": "Washington",
                "Min": 98001,
                "Max": 99403
            },
            {
                "State": "West Virginia",
                "Min": 24701,
                "Max": 26886
            },
            {
                "State": "Wisconsin",
                "Min": 53001,
                "Max": 54990
            },
            {
                "State": "Wyoming",
                "Min": 82001,
                "Max": 83414
            },
            {
                "State": "American Samoa",
                "Min": 96799,
                "Max": 96799
            },
            {
                "State": "Guam",
                "Min": 96910,
                "Max": 96932
            },
            {
                "State": "Northern Mariana Islands",
                "Min": 96950,
                "Max": 96952
            },
            {
                "State": "Palau",
                "Min": 96939,
                "Max": 96940
            },
            {
                "State": "Marshall Islands",
                "Min": 96960,
                "Max": 96970
            },
            {
                "State": "Puerto Rico",
                "Min": 601,
                "Max": 988
            },
            {
                "State": "District of Columbia",
                "Min": 20001,
                "Max": 20500
            },
            {
                "State": "Federated States Of Micronesia",
                "Min": 96941,
                "Max": 96944
            },
            {
                "State": "Virginia Islands",
                "Min": 801,
                "Max": 851
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./public/app/_services/data.service.ts